export function LoadingTerminal({ message }: { message: string }) {
  return (
    <main className="loading-shell" aria-live="polite" aria-busy="true">
      <div className="loading-terminal" aria-hidden="true">
        <div className="skeleton-ticker"><i /><i /><i /></div>
        <div className="skeleton-chart"><i /><i /><i /><i /></div>
      </div>
      <p>{message}</p>
    </main>
  );
}
